import { useState } from "react";
import { Mail, Check, Send, Loader2, Wrench, Sparkles } from "lucide-react";
import { api, apiError } from "@/lib/api";

const PHOTO = `${process.env.REACT_APP_BACKEND_URL}/api/questions/photo/`;
const CAT_LABEL = { bug: "Bug", idea: "Idea", howto: "How-to", payment: "Payment", other: "Other" };

export function QuestionItem({ q, t, onChange }) {
  const ai = q.ai;
  const [draft, setDraft] = useState(ai?.draft_reply || "");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const toggle = async () => {
    const status = q.status === "answered" ? "new" : "answered";
    try { await api.setQuestionStatus(q.id, status); setErr(""); onChange({ ...q, status }); }
    catch { setErr(t("Something went wrong. Try again.")); }
  };
  const send = async () => {
    setBusy(true); setErr("");
    try { const r = await api.replyQuestion(q.id, draft); onChange({ ...q, ...r }); }
    catch (e) { setErr(apiError(e) || t("Something went wrong. Try again.")); }
    finally { setBusy(false); }
  };

  return (
    <div className={`inbox-item ${q.status === "answered" ? "inbox-done" : ""}`} data-testid={`inbox-item-${q.id}`} data-no-metric="">
      <div className="inbox-top">
        {ai && <span className={`cat-chip cat-${ai.category}`} data-testid={`inbox-category-${q.id}`}>{t(CAT_LABEL[ai.category])}</span>}
        <div className="card-sub">{q.name || q.email} · {new Date(q.created_at).toLocaleString()}</div>
      </div>
      <div className="inbox-msg">{q.message}</div>
      {q.photo_tokens?.length > 0 && (
        <div className="photo-row" data-testid={`inbox-photos-${q.id}`}>
          {q.photo_tokens.map((tok, i) => (
            <a key={tok} href={PHOTO + tok} target="_blank" rel="noreferrer" className="photo-thumb" data-testid={`inbox-photo-${q.id}-${i}`}>
              <img src={PHOTO + tok} alt={t("Driver photo")} loading="lazy" /></a>
          ))}
        </div>
      )}
      {ai?.summary && <div className="ai-line" data-testid={`inbox-summary-${q.id}`}><Sparkles size={13} />{ai.summary}</div>}
      {ai?.fix_note && <div className="ai-fix" data-testid={`inbox-fix-${q.id}`}><Wrench size={13} /><span>{ai.fix_note}</span></div>}
      {q.reply_text ? (
        <div className="ai-replied" data-testid={`inbox-replied-${q.id}`}><Check size={13} />{t("Replied")}: {q.reply_text}</div>
      ) : ai?.draft_reply ? (
        <>
          <div className="label">{t("AI draft reply")}</div>
          <textarea className="text-input ask-text" data-testid={`inbox-draft-${q.id}`} value={draft} maxLength={4000} onChange={(e) => setDraft(e.target.value)} />
        </>
      ) : null}
      {err && <div className="form-error" data-testid={`inbox-error-${q.id}`}>{err}</div>}
      <div className="action-row inbox-actions">
        {!q.reply_text && ai?.draft_reply && (
          <button type="button" className="primary-btn inbox-btn" data-testid={`inbox-send-reply-${q.id}`} disabled={busy || draft.trim().length < 2} onClick={send}>
            {busy ? <Loader2 size={14} className="spin" /> : <Send size={14} />}{t("Send reply")}</button>
        )}
        <a className="ghost-btn inbox-btn" href={`mailto:${q.email}?subject=${encodeURIComponent("Re: your Fuel Hauler Pro question")}`} data-testid={`inbox-reply-${q.id}`}>
          <Mail size={14} />{t("Reply")}</a>
        <button type="button" className="ghost-btn inbox-btn" data-testid={`inbox-toggle-${q.id}`} onClick={toggle}>
          <Check size={14} />{q.status === "answered" ? t("Mark new") : t("Mark answered")}</button>
      </div>
    </div>
  );
}
